import React from "react";
import { useHistory } from "react-router";
import check from "../assets/check.svg";
import Input from "../form-components/Input";
import * as Yup from "yup";
import { HomeWrapper } from "./Login";
import "./styles/login.css";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { register, reset_register } from "../actions/auth/Action";
import { toast } from "react-toastify";
import { useEffect } from "react";

const SignUpSchema = Yup.object().shape({
  email: Yup.string().email("Enter valid email.").required("Email is required"),
  name: Yup.string().required(),
  phone: Yup.string().required(),
  company: Yup.string().required(),
  message: Yup.string().required(),
  address: Yup.string().required(),
});

const SignUp = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const signupRes = useSelector((state) => state?.auth?.register);
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      phone: "",
      company: "",
      message: "",
    },
    onSubmit: (vals) => {
      dispatch(register({ user: vals }));
    },
    validationSchema:SignUpSchema
  });

  useEffect(() => {
    if (signupRes && signupRes.success) {
      toast.success("Signup Success, please login.");
      dispatch(reset_register());
      history.push("/");
    }

    if (signupRes && signupRes.success === false) {
      toast.error(signupRes?.data?.message);
      dispatch(reset_register());
    }
    // eslint-disable-next-line
  }, [signupRes]);

  return (
    <HomeWrapper>
      <form className="flex-center" onSubmit={formik.handleSubmit}>
        <div className="w70">
          <div className="head-sec">
            <h3 className="text-heading">Open a OMNI account</h3>
            <span className="text-sub-heading">
              Just fill in the details below and we will call you back within
              one business day to complete the account opening process.
            </span>
          </div>
          <Input placeholder={"Enter name"} formik={formik} name="name" />
          <Input placeholder={"Enter email"} formik={formik} name="email" />
          <Input placeholder={"Enter phone"} formik={formik} name="phone" />
          <Input
            placeholder={"Enter company name"}
            formik={formik}
            name="company"
          />
          <Input placeholder={"Message"} formik={formik} name="message" />
          <Input placeholder={"Address"} formik={formik} name="address" />
          <div className="terms">
            <span className="check">
              <img alt="check" src={check} />
            </span>
            I have agreed to the <span>Terms of Conditions</span> and{" "}
            <span>Privacy Policy</span>
          </div>
          <div className="v-center mt2">
            <button className="primary-btn mr1">Submit</button>
          </div>
        </div>
      </form>
    </HomeWrapper>
  );
};

export default SignUp;
